<template>
  <BCard
    :id="id"
    class="rs-popout shadow-lg overflow-auto"
    :style="{ width: width || '90%', transitionDuration: `${transitionDuration}ms` }"
    :class="{ show: value }"
    no-body
  >
    <div class="d-flex flex-column h-100">
      <div class="position-relative">
        <slot name="header">
          <h4 class="p-3 text-center border-bottom mb-0">
            {{ title }}
          </h4>
        </slot>

        <h4
          v-if="!noCancel"
          class="position-absolute cursor-pointer mb-0"
          style="top: 1rem; right: 1rem; z-index: 1"
        >
          <span @click="handleCancel">
            <RsIcon icon="times" />
          </span>
        </h4>
      </div>

      <div class="flex-fill">
        <div
          v-if="isSlideComplete"
          class="h-100"
        >
          <slot />
        </div>
      </div>

      <BCardFooter
        v-if="!noFooter"
        class="border-top bg-white py-2 px-3 position-sticky"
        style="left: auto; right: 0; bottom: 0; width: 100%"
      >
        <slot name="footer">
          <div class="d-flex">
            <div class="flex-fill" />
            <RsButton
              class="mr-2"
              variant="cancel"
              @click="handleCancel"
            >
              {{ $ts('actions.cancel') }}
            </RsButton>
            <RsButton
              v-if="isUpdatePermitted"
              variant="primary"
              :disabled="isSaveDisabled"
              @click="handleSave"
            >
              {{ $ts('actions.save') }}
            </RsButton>
          </div>
        </slot>
      </BCardFooter>
    </div>
  </BCard>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

const initialState = {
  eventsMap: {
    onSubmit: 'on-submit',
    onCancel: 'on-cancel',
    onClose: 'on-close',
    input: 'input',
  },
  isSlideComplete: false as boolean,
  transitionDuration: 300 as number,
};

export default defineComponent({
  props: {
    id: String,
    value: Boolean,
    title: String,
    width: String,
    noFooter: Boolean,
    noCancel: Boolean,
    isSaveDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return initialState;
  },

  watch: {
    value: {
      immediate: true,
      handler() {
        if (this.value) {
          document.body.classList.add('rs-popout-visible');
          setTimeout(() => {
            this.isSlideComplete = true;
          }, this.transitionDuration);
        } else {
          this.isSlideComplete = false;
          setTimeout(() => {
            document.body.classList.remove('rs-popout-visible');
          }, this.transitionDuration);
        }
      },
    },
  },

  methods: {
    handleCancel() {
      this.$emit(this.eventsMap.input, false);
    },

    handleSave() {
      this.$emit(this.eventsMap.onSubmit);
    },
  },
});
</script>

<style lang="scss">
@import '@/styles/_variables';

.rs-popout.card {
  padding: 0;
  position: fixed;
  right: -100%;
  top: 0;
  bottom: 0;
  height: 100vh;
  max-height: 100vh;
  z-index: 3000;
  border-top-left-radius: $global-radius;
  border-bottom-left-radius: $global-radius;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  transition-property: right;
  transition-timing-function: ease-in-out;

  &.show {
    right: 0;
  }

  .card-body {
    padding: 0;
  }

  .os-scrollbar {
    z-index: 1 !important;
  }
}

/* When popout is open, customize css (tackles z-index issues) */
body.rs-popout-visible {
  .footer-bar, .footer-bar *, .os-scrollbar {
    z-index: -1 !important;
  }
}
</style>
